import { Calculator, ShowErrorWay } from "../../common/calculator";
import {fields} from "../../common/basic_fields.js";

class VatCalculator extends Calculator{
    code() { return 'vat'; }
    type() { return "CalcValueAddedTax"; }

    initialize(){
        let self = this;

        this.submitOnChange();
        this.calcName = "Nachislit_nds";

        this.addInputField("#sumInput", "sumInput", {
            type: 'money',
            errors: [{ check: function (v) { return v !== null && v > 0 }, errClassElem: "" }],
            options: {keyup: true },
        });

        this.addInputField("#rateInput", "rate", {
            type: 'float', 
            options: { keyup: true, precision: 2 }
        });

        this.addOutputField("#calcFormulaEx1", "formulaEx1", {render: (x) => x, html:true});
        this.addOutputField("#calcFormulaEx2", "formulaEx2", {render: (x) => x, html:true});
        this.addOutputField("#inputRateVal", "rate", {render: (x) => x? x: "0"});
        

        $(".calc-div-input-fields .hardcoded-vat-rates.fixed-rates > a").click(function () {
            var val = $(this).html();
            $('#rateInput').val(val.substring(0, val.length - 1));
            self.autoSubmit();
        });

        $(".calc-div-input-fields .fixed-rates a").click(function(e){
            self.autoSubmit();
            if(self.isActive)
                self.sendRateStatisticMessage(self.calcName, self.rate+"%");
        });

        let inputStavkaStatistic = (type, value) => {
            let goalParams = {
                message: "Input_stavka",
                prefix: "",
                args:{
                    type, 
                    value
                }
            };
            self.sendStatisticMessage(goalParams);
        }

        $("#rateInput").blur((function(){
            if(self.isActive && self.rate !== undefined && self.rate !== null)
                inputStavkaStatistic(self.calcName, `${self.rate}%`);
        }));

        $("#calculatedRateInput").blur((function(){
            if(self.isActive && self.calculatedRate)
                inputStavkaStatistic(self.calcName, `${self.calculatedRate}/${self.calculatedRate + 100}`);
        }));

        $("#rateInput, #calculatedRateInput, #sumInput").click(function(){
            if(this.selectionStart == this.selectionEnd)
                tools.selectAllText.apply(this);
        });

        $(".results-div").on('copy', function(){
            if(self.isActive){
                let goalParams = {
                    message: "Copy",
                    prefix: "",
                    args:{
                        text: window.getSelection().toString()
                    }
                };
                self.sendStatisticMessage(goalParams);
            }
        });
    }

    renderError(){
        this.mainBlockVal = "0,00";
        this.formulaEx1 = "";
        this.formulaEx2 = "";
        this.sumInput = "0,00";
        this.inputRateVal = "0"

        this.render();
    }

    generateExportObject(){
        let result = super.generateExportObject();
        result.inputTitle = this.inputTitle;
        result.rateTitle = this.rateTitle;
        result.render.rate_text += (this.rateTitle == "Ставка НДС" || result.render.rate_text == "16.67" || result.render.rate_text == "9.09" ? "%" : "");
        return result;
    }

    sendRateStatisticMessage(type, value){
        let goalParams = {
            message: "Stavka",
            prefix: "",
            args:{
                type,
                value
            }
        };
        this.sendStatisticMessage(goalParams);
    }
}

export {VatCalculator}
